import React, { Fragment, useState, useCallback } from "react";
import { Row, Col, Form, Alert } from "reactstrap";
import { useDropzone } from "react-dropzone";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  SET_STEP_2_UPLOAD_DOCUMENTS,
  DOCUMENT_GOTO_NEXT_STEP,
} from "../../../redux/actions/ActionTypes";
import Swal from "sweetalert2";
import {
  getAlertToast,
  getAlert,
} from "../../../utils/functions/CustomFunctions";
import {
  AGENCY_DOCUMENT_UPDATE_URL,
  PDF_PAGES_SPLIT_INTO_DOCUMENTS_URL,
} from "../../../utils/APIEndpoints";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import CanvasComponent from "./CanvasComponent";
import CustomLoader from "../../common/CustomLoader";
import BuildDocument from "./BuildDocument";
import CustomPageLoading from "../../../utils/functions/CustomPageLoading";
function STEP_TWO_BUILD_DOCUMENT(props) {
  const {
    CreateDocumentForm = {},
    dispatch,
    isPreviewDocument = false,
    documentsList = [],
  } = props;

  const { step2 = {}, currentStep, agencyServiceId } = CreateDocumentForm;

  const [loading, setLoading] = useState(false);

  // Drag and Drop
  const onDrop = useCallback((acceptedFiles) => {
    Swal.fire(getAlertToast("success", "Please wait..."));
    acceptedFiles.length &&
      acceptedFiles.map(async (currentFile) => {
        try {
          setLoading(true);
          const formData = new FormData();
          formData.append("file", currentFile);
          const options = {
            method: "POST",
            url: PDF_PAGES_SPLIT_INTO_DOCUMENTS_URL,
            headers: authHeader(),
            data: formData,
          };

          var apiResponse = await API(options);
          const { status } = apiResponse.data;
          if (status === "Success") {
            const { objList: documentURLList = [] } = apiResponse.data;
            dispatch({
              type: SET_STEP_2_UPLOAD_DOCUMENTS,
              payload: documentURLList,
            });
          }
        } catch (error) {
          if (error.response) {
            let { data } = error.response;
            Swal.fire(getAlert("error", data.message));
          }
        } finally {
          setLoading(false);
        }
      });
  }, []);

  //Submit Form
  const submitFormData = async (event) => {
    event.preventDefault();

    if (documentsList.length) {
      let filledDocument = documentsList.find(
        (document) => document.elements.length
      );
      if (filledDocument) {
        try {
          let storeData = {
            agencyServiceId,
            templatePlaceHolderValue: JSON.stringify(documentsList),
            isSubmitAdmin: false,
          };
          const options = {
            method: "PUT",
            url: AGENCY_DOCUMENT_UPDATE_URL,
            headers: authHeader(),
            data: storeData,
          };
          Swal.fire(getAlertToast("success", "Please wait..."));
          var apiResponse = await API(options);
          const { status, message } = apiResponse.data;
          if (status === "Error") {
            Swal.fire(getAlertToast("error", message));
          } else {
            Swal.fire(
              getAlertToast("success", "Placeholders added to this document")
            );
            dispatch({
              type: DOCUMENT_GOTO_NEXT_STEP,
              payload: currentStep,
            });
          }
        } catch (error) {
          if (error.response) {
            let { data } = error.response;
            Swal.fire(getAlertToast("error", data.message));
          }
        }
      } else {
        dispatch({
          type: DOCUMENT_GOTO_NEXT_STEP,
          payload: currentStep,
        });
      }
    } else {
      Swal.fire(getAlert("error", "Please upload a file"));
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "application/pdf",
  });

  return (
    <Fragment>
      {/* {loading && <CustomPageLoading />} */}
      <center>{loading && <CustomLoader loading={loading} />}</center>
      {!!documentsList.length && !isPreviewDocument && (
        <div>
          <Alert color="secondary">
            Click on the document to add placeholder!
          </Alert>
          <Alert color="secondary">Ctrl/Cmd + Drag to duplicate element</Alert>
        </div>
      )}

      {!!documentsList.length && (
        <Row>
          <Col sm={2} />
          <Col sm={8}>
            <center>
              {documentsList.map((record, index) => (
                <Fragment key={`canvas_list_${index}`}>
                  {!isPreviewDocument ? (
                    <BuildDocument documentIndex={index} record={record} />
                  ) : (
                    <CanvasComponent documentIndex={index} record={record} />
                  )}
                </Fragment>
              ))}
            </center>
          </Col>
          <Col sm={2} />
        </Row>
      )}

      <br />

      {!isPreviewDocument && (
        <Form form="true" onSubmit={submitFormData} id="form_step_4">
          <div className="uploadFile-box">
            <div {...getRootProps()} style={{ cursor: "pointer" }}>
              <input {...getInputProps()} />
              {isDragActive ? (
                <p>Drop the file here ...</p>
              ) : (
                <p>Drag 'n' drop file here, or click to select file</p>
              )}
            </div>
          </div>
        </Form>
      )}
    </Fragment>
  );
}

const getState = ({ CreateDocumentForm }) => {
  return {
    CreateDocumentForm,
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      //
    },
    dispatch
  ),
  dispatch,
});
export default connect(getState, mapDispatchToProps)(STEP_TWO_BUILD_DOCUMENT);
